import React from "react";
import type { IIcon } from "./icons.types";

const Copy: React.FC<IIcon> = ({
  width = 46,
  height = 46,
  color = "currentColor"
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_4411:1433)">
      <path
        d="M32.0586 7.71582H6.14633C5.20561 7.71582 4.44049 8.48094 4.44049 9.42166V43.8568C4.44049 44.7975 5.20561 45.5626 6.14633 45.5626H32.0586C32.9984 45.5626 33.7636 44.7975 33.7636 43.8568V9.42166C33.7636 8.48094 32.9984 7.71582 32.0586 7.71582ZM26.2752 31.734H12.4465C11.6423 31.734 10.9909 31.0826 10.9909 30.2783C10.9909 29.4741 11.6423 28.8227 12.4465 28.8227H26.2752C27.0794 28.8227 27.7308 29.4741 27.7308 30.2783C27.7308 31.0826 27.0794 31.734 26.2752 31.734ZM26.2752 25.9114H12.4465C11.6423 25.9114 10.9909 25.26 10.9909 24.4557C10.9909 23.6515 11.6423 23.0001 12.4465 23.0001H26.2752C27.0794 23.0001 27.7308 23.6515 27.7308 24.4557C27.7308 25.26 27.0794 25.9114 26.2752 25.9114ZM26.2752 20.0888H12.4465C11.6423 20.0888 10.9909 19.4374 10.9909 18.6332C10.9909 17.8289 11.6423 17.1775 12.4465 17.1775H26.2752C27.0794 17.1775 27.7308 17.8289 27.7308 18.6332C27.7308 19.4374 27.0794 20.0888 26.2752 20.0888Z"
        fill={color}
      />
      <path
        d="M41.5597 4.80444V36.8286C41.5597 39.0267 39.791 41.1956 36.6751 41.1956V9.42156C36.6751 6.87509 34.6044 4.80444 32.0589 4.80444H9.32532C9.32532 2.39625 11.4005 0.4375 13.9506 0.4375H36.9344C39.4845 0.4375 41.5597 2.39625 41.5597 4.80444Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_4411:1433">
        <rect
          width="45.125"
          height="45.125"
          fill="white"
          transform="translate(0.4375 0.4375)"
        />
      </clipPath>
    </defs>
  </svg>
);

export { Copy };
